/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_Col_PlanInputs */

const es_admin_billing_bills_list_col_plan = /** @type {(inputs: Admin_Billing_Bills_List_Col_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const en_admin_billing_bills_list_col_plan = /** @type {(inputs: Admin_Billing_Bills_List_Col_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Admin_Billing_Bills_List_Col_PlanInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_col_plan = /** @type {((inputs?: Admin_Billing_Bills_List_Col_PlanInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Col_PlanInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_col_plan(inputs)
	return en_admin_billing_bills_list_col_plan(inputs)
});
export { admin_billing_bills_list_col_plan as "admin.billing.bills_list.col_plan" }